import { DownOutlined, BankOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { MOBILE_WIDTH } from "datastake-daf/src/constants/Style";

const Style = styled.div`
  display: flex;
  cursor: pointer;

  .desktop {
    display: flex;
  }

  .mobile {
    display: none;
  }

  .icon-c {
    width: 40px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 100%;
    background-position: center !important;
    background-size: cover !important;

    .anticon {
      line-height: 0px !important;
      padding-left: 0px !important;
      font-size: 18px;
      svg {
        color: #D2D6DB;
      }
    }

    svg {
      margin: auto;
    }

    svg {
      color: black;
    }
  }

  .cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media (${MOBILE_WIDTH}) {
    .desktop {
      display: none;
    }

    .mobile {
      display: flex;
      cursor: pointer;

      .anticon-menu {
        padding-left: 0px !important;
      }
    }
  }
`;

export default function UserIcon({ companyLogo }) {
  if (companyLogo) {
    return (
      <Style>
        <div className="flex">
          <div className="cont">
            <div className="icon-c cont" style={{ background: `url('${companyLogo}')` }} />
          </div>
          <div className="cont">
            <DownOutlined />
          </div>
        </div>
      </Style>
    )
  }
  return (
    <Style>
      <div className="flex">
        <div className="cont">
          <div className="icon-c cont">
            <BankOutlined />
          </div>
        </div>
        <div className="cont">
          <DownOutlined />
        </div>
      </div>
    </Style>
  );
}
